module.exports = __webpack_public_path__ + "static/media/cinema-break.93b495b4.webp";